import { VENMO_AUTOMATION_STAGE_STATUSES } from './venmoAutomationStageStatuses'
import { authHomeUrl } from './venmoUrls'
import { updatePlatformUserAccountData } from '../../data/platform/platformUserAccountData'
import { PLATFORM, StageType } from '../../utils/enums'
import { StageDef } from '../automationMachineInterfaces'
import { getOptionalElement } from '../utils'

enum StageKey {
  GATHER_ACCOUNT_USERNAME = 'GATHER_ACCOUNT_USERNAME',
}

async function getUsernameFromHomepage(): Promise<string | null> {
  const element = await getOptionalElement<HTMLElement>(
    document,
    "descendant::*[starts-with(text(), '@') and not(self::style)]",
  )

  if (element) {
    // Trim whitespace; remove '@' from beginning
    return element.textContent?.trim()?.slice(1)
  }
  return null
}

export const gatherAccountUsernameStageDef: StageDef = {
  type: StageType.ACTION,
  key: StageKey.GATHER_ACCOUNT_USERNAME,
  status: VENMO_AUTOMATION_STAGE_STATUSES.GATHERING_SETTINGS,
  url: authHomeUrl,
  action: async (machineContext, userContext) => {
    const { platform, userId } = userContext
    const username = await getUsernameFromHomepage()
    if (username) {
      await updatePlatformUserAccountData(platform as PLATFORM, userId, {
        username,
      })
    }
  },
}
